const keyOf = (item) => [
  item.purpose || 'required', item.asset_category,
  item.surface || item.aperture_type || item.asset?.aperture_type || '', item.asset_uuid,
].join(':');
const groupObjects = (items) => {
  const groups = new Map();
  items.forEach((item) => {
    const purpose = item.purpose || 'required';
    const key = `${item.group_id || `room:${item.room_type_id ?? 'all'}`}:${purpose}`;
    if (!groups.has(key)) {
      groups.set(key, {
        id: key, sourceId: item.group_id, purpose, rooms: [], objects: [], entries: [],
      });
    }
    const group = groups.get(key);
    const room = item.room_type_id ?? null;
    if (!group.rooms.includes(room)) group.rooms.push(room);
    if (!group.objects.some((object) => keyOf(object) === keyOf(item))) group.objects.push(item);
    group.entries.push(item);
  });
  return [...groups.values()];
};
const buildRoomGroup = (groupId, rooms, objects) => rooms.flatMap((room) => objects.map((item) => ({
  ...item,
  id: `${groupId}:${room ?? 'all'}:${keyOf(item)}`,
  group_id: groupId,
  room_type_id: room,
})));
export { groupObjects, buildRoomGroup, keyOf };
